module.exports = __webpack_public_path__ + "img/1728955800671-Screenshot_15-10-2024_92937_www.instagram.com.jpeg.ccc312cd.webp";